import React from 'react';
import { motion } from 'framer-motion';
import AboutImage from '../../assets/About.webp';
import '../../styles/About.css';
import About1 from '../../assets/About1.webp';
import About2 from '../../assets/About2.webp';
import About3 from '../../assets/About3.webp';
import About4 from '../../assets/About4.webp';

const About = () => {
  return (
    <motion.section className="about-section">
      <div className="about-container">
        <motion.img
          src={AboutImage}
          alt="About Synthetica"
          className="about-image"
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        />
        <p>
          Welcome to Synthetica, the ultimate tool for discerning the origin of your text content.
          Whether you're curious about the authenticity of a poem, song, essay, or any piece of writing,
          our advanced AI-powered platform can help you identify whether it was crafted by a human or
          generated by artificial intelligence.
        </p>
        <div className="features-container">
          <motion.img
            src={About1}
            alt="Feature 1"
            className="feature-block"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          />
          <motion.img
            src={About2}
            alt="Feature 2"
            className="feature-block"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.4 }}
          />
          <motion.img
            src={About3}
            alt="Feature 3"
            className="feature-block"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.6 }}
          />
          <motion.img
            src={About4}
            alt="Feature 4"
            className="feature-block"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.8 }}
          />
        </div>
      </div>
    </motion.section>
  );
};

export default About;
